import {useMemo} from 'react';

import {useNumPanelsByKey} from './useNumPanelsByKey';
import {useSearchedKeys} from './useSearchedKeys';

export const useQuickAddKeys = (searchStr = '') => {
  const searchedKeys = useSearchedKeys(searchStr);
  const numPanelsByKey = useNumPanelsByKey();
  const keysWithNoPanels = useMemo(
    () => searchedKeys.filter(([key]) => !numPanelsByKey.global.get(key)),
    [searchedKeys, numPanelsByKey]
  );
  return {
    searchedKeys,
    numPanelsByKey,
    keysWithNoPanels,
  };
};
